import { CardDiscount } from '@/common/components/CardDiscount/CardDiscount';
import { Grid } from '@/common/components/Grid/Grid';
import { IDiscount } from '@/common/integrations/menhir/employee/discounts/discounts.types';

export type TDiscountsListProps = {
  discounts: IDiscount[];
};

export function DiscountsList({ discounts }: TDiscountsListProps) {
  return (
    <Grid columnBasis="basis-[24rem]" gap="sibling-card">
      {discounts.map((discount) => (
        <CardDiscount
          key={discount.id}
          discount={discount}
          className={styles.card}
        />
      ))}
    </Grid>
  );
}

const styles = {
  card: 'flex-1',
};
